module.exports = __webpack_public_path__ + "img/ic-upload-file.fdcc5e96.svg";